var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3891 18.3335C11.3716 18.3335 11.3549 18.3327 11.3383 18.3319C10.9616 18.3094 10.6474 18.036 10.5724 17.666L9.29075 11.3602C9.22408 11.0319 8.96825 10.776 8.63992 10.7094L2.33408 9.42688C1.96408 9.35271 1.69075 9.03854 1.66825 8.66188C1.64575 8.28438 1.87825 7.93938 2.23658 7.82104L15.5699 3.37688C15.8691 3.27521 16.1991 3.35354 16.4224 3.57771C16.6458 3.80104 16.7233 4.13104 16.6241 4.43021L12.1791 17.7635C12.0658 18.106 11.7458 18.3335 11.3891 18.3335",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8019_191211",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3891 18.3335C11.3716 18.3335 11.3549 18.3327 11.3383 18.3319C10.9616 18.3094 10.6474 18.036 10.5724 17.666L9.29075 11.3602C9.22408 11.0319 8.96825 10.776 8.63992 10.7094L2.33408 9.42688C1.96408 9.35271 1.69075 9.03854 1.66825 8.66188C1.64575 8.28438 1.87825 7.93938 2.23658 7.82104L15.5699 3.37688C15.8691 3.27521 16.1991 3.35354 16.4224 3.57771C16.6458 3.80104 16.7233 4.13104 16.6241 4.43021L12.1791 17.7635C12.0658 18.106 11.7458 18.3335 11.3891 18.3335",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8019_191211)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/send-message-icon.de0d2b8b33215cde1c1cf8da48647b51.svg";
export { ForwardRef as ReactComponent };